import keyMirror from 'keymirror';

export const addWysiwygVideoModalActionTypes = keyMirror({
	HANDLE_ADD_WYSIWYG_VIDEO_MODAL: null,
});

export const VIMEO_URL_PLACEHOLDER = 'https://player.vimeo.com/video/:id';
